const mistakes = [
  { title: "Military Timeline Mismatch", desc: "PCS orders often come with very little notice. Start your passport renewal before deployment orders arrive — not after." },
  { title: "Wrong Photo", desc: "Fort Smith post office photos are commonly rejected. We verify exact specifications before submission." },
  { title: "Missing Birth Certificate Seal", desc: "A birth certificate without a raised or embossed seal is rejected. We check your documents before you make the trip." },
  { title: "Late Application Starts", desc: "Many Fort Smith residents wait until a month before travel. We recommend 6–8 weeks for standard processing." },
  { title: "Wrong Form Selection", desc: "DS-11 vs DS-82 is a common source of confusion. We identify the correct form for your situation immediately." },
];

export default function FortSmithMistakesSection() {
  return (
    <section id="mistakes" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">5 Mistakes Fort Smith Applicants Make</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4"><i className="ri-close-circle-line text-red-500 text-xl"></i></div>
              <h3 className="font-bold text-[#1A365D] text-lg mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}